import { Indexable } from '../types/helpers';

const routes: Indexable = {
  HOME: '/',
  RENTAL: '/:propertyType/:slug',
};

export default Object.freeze(routes);
